module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "ui dimmable dimmed segment"
  }, [_c('div', {
    staticClass: "ui simple dimmer"
  }), _vm._v(" "), _c('mosaic')], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', _vm._l((_vm.links), function(link) {
    return _c('site', {
      attrs: {
        "logo": link.logo,
        "link": link.link
      }
    }, [_vm._v(_vm._s(link.name))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f00bd02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 130
// module chunks = 2